import UbahFakturPenjualan from './UbahFakturPenjualan'

export default UbahFakturPenjualan